<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalCopyPosSettings"
      id="show-modal-copy-pos-settings"
    ></material-button>
    <material-button
      class="d-none"
      data-bs-dismiss="modal"
      data-bs-target="#modalCopyPosSettings"
      id="hide-modal-copy-pos-settings"
    ></material-button>

    <div
      class="modal fade"
      id="modalCopyPosSettings"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Copy POS Settings to Other Branches</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              @click="closeModal()"
              >clear</i
            >
          </div>

          <div class="modal-body" v-if="step === 'select'">
            <div class="w-100 mb-3">
              <label class="fw-bold mb-1 me-1" for="">Copy from</label>
              <div class="source-pill">
                <i class="material-icons text-sm align-middle me-1">storefront</i>{{ sourceBranchName }}
              </div>
            </div>
            <div class="w-100 mb-1">
              <label class="fw-bold" for="">Copy to</label>
              <Multiselect
                v-model="copySettings.branch_ids"
                mode="tags"
                :close-on-select="false"
                :searchable="true"
                :options="branches"
                placeholder="Select destination branches"
                :canClear="true"
              />
            </div>
            <div class="w-100 mb-3">
              <span class="is-invalid" v-if="fieldRequired.isBranchRequired"
                >Select at least one destination branch.</span
              >
            </div>
            <div class="w-100 mb-1">
              <div class="d-flex align-items-center justify-content-between">
                <label class="fw-bold mb-0" for="">Settings to copy</label>
                <a href="javascript:;" class="text-sm select-all-link" @click="toggleAllGroups()">
                  {{ allGroupsSelected ? "Clear all" : "Select all" }}
                </a>
              </div>
              <div class="row mt-1">
                <div
                  class="col-6 d-flex align-items-center label-form"
                  v-for="group in groupOptions"
                  :key="group.key"
                >
                  <material-checkbox
                    @change="toggleGroup(group.key, $event.target.checked)"
                    :model-value="copySettings.groups.includes(group.key)"
                    :checked="copySettings.groups.includes(group.key)"
                    :name="group.key"
                    class="align-items-center px-3"
                  ></material-checkbox>
                  {{ group.label }}
                </div>
              </div>
            </div>
            <div class="w-100 mb-1">
              <span class="is-invalid" v-if="fieldRequired.isGroupRequired"
                >Select at least one setting group.</span
              >
            </div>
          </div>

          <div class="modal-body" v-else>
            <div class="alert alert-warning py-2 px-3 mb-3">
              <i class="material-icons text-sm align-middle me-1">warning</i>
              You are about to overwrite POS settings for
              <b>{{ copySettings.branch_ids.length }}</b> branch(es). This cannot be undone.
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold mb-1 me-1">Source</label>
              <div class="source-pill">
                <i class="material-icons text-sm align-middle me-1">storefront</i>{{ sourceBranchName }}
              </div>
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold mb-1">Targets</label>
              <div class="d-flex flex-wrap" style="gap: 6px">
                <span class="badge badge-sm bg-gradient-info" v-for="name in destinationNames" :key="name">
                  {{ name }}
                </span>
              </div>
            </div>
            <div class="w-100 mb-1">
              <label class="fw-bold mb-1">Settings</label>
              <div class="d-flex flex-wrap" style="gap: 6px">
                <span class="badge badge-sm bg-gradient-secondary" v-for="label in selectedGroupLabels" :key="label">
                  {{ label }}
                </span>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="d-flex mt-3" v-if="step === 'select'">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="goToConfirm()"
              >
                Next
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-outline-secondary"
                @click="closeModal()"
              >
                Cancel
              </material-button>
            </div>
            <div class="d-flex mt-3" v-else>
              <material-button
                class="mx-2 btn btn-sm btn-background"
                :disabled="isCopying"
                @click="confirmCopy()"
              >
                Confirm Copy
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-outline-secondary"
                :disabled="isCopying"
                @click="step = 'select'"
              >
                Back
              </material-button>
            </div>
          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import Multiselect from "@vueform/multiselect";
import TestService from "../services/test.service";
import SettingPosService from "../services/settingPos.service";

export default {
  name: "copy-pos-settings-to-branches",
  components: {
    MaterialButton,
    MaterialCheckbox,
    MaterialLoading,
    MaterialSnackbar,
    Multiselect,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    sourceBranchId: {
      type: Number,
      default: 0,
    },
    sourceBranchName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      isCopying: false,
      fieldRequired: {},
      step: "select",
      branches: [],
      groupOptions: [
        { key: "service_charge", label: "Service Charge" },
        { key: "takeaway_service_charge", label: "Takeaway Service Charge" },
        { key: "cash_rounding", label: "Cash Rounding" },
        { key: "redeem", label: "Redeem" },
        { key: "bcrs", label: "BCRS" },
        { key: "email", label: "Email" },
        { key: "discount", label: "Discount" },
        { key: "payment_method", label: "Payment Method" },
      ],
      copySettings: {
        branch_ids: [],
        groups: [],
      },
    };
  },
  computed: {
    destinationNames() {
      return this.branches
        .filter((branch) => this.copySettings.branch_ids.includes(branch.value))
        .map((branch) => branch.label);
    },

    selectedGroupLabels() {
      return this.groupOptions
        .filter((group) => this.copySettings.groups.includes(group.key))
        .map((group) => group.label);
    },

    allGroupsSelected() {
      return this.copySettings.groups.length === this.groupOptions.length;
    },
  },
  methods: {
    getBranches() {
      TestService.getBranches().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branches = response.data.data.filter(
              (branch) => branch.value !== this.sourceBranchId
            );
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.setTimeOutNotification();
        }
      );
    },

    toggleGroup(key, checked) {
      const groups = this.copySettings.groups.filter((g) => g !== key);

      if (checked) {
        groups.push(key);
      }

      this.copySettings.groups = groups;
    },

    toggleAllGroups() {
      this.copySettings.groups = this.allGroupsSelected
        ? []
        : this.groupOptions.map((group) => group.key);
    },

    processValidate() {
      this.fieldRequired.isBranchRequired = this.copySettings.branch_ids.length === 0;
      this.fieldRequired.isGroupRequired = this.copySettings.groups.length === 0;

      return !this.fieldRequired.isBranchRequired && !this.fieldRequired.isGroupRequired;
    },

    goToConfirm() {
      if (!this.processValidate()) {
        return;
      }

      this.step = "confirm";
    },

    confirmCopy() {
      if (this.isCopying) {
        return;
      }

      this.isCopying = true;
      this.loaderActive = true;

      SettingPosService.copyToBranches({
        source_branch_id: this.sourceBranchId,
        destination_branch_ids: this.copySettings.branch_ids,
        groups: this.copySettings.groups,
        commit: true,
      }).then(
        (response) => {
          this.isCopying = false;
          this.loaderActive = false;

          if (response.data.result.isSuccess) {
            this.$emit("copied", response.data.data);
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.isCopying = false;
          this.loaderActive = false;
          this.snackbar = "danger";
          this.message = this.errorMessage(error);
          this.setTimeOutNotification();
        }
      );
    },

    closeModal() {
      if (this.isCopying) {
        return;
      }

      this.$emit("close-copy-pos-settings");
    },

    clearData() {
      this.step = "select";
      this.isCopying = false;
      this.fieldRequired = {};
      this.copySettings = {
        branch_ids: [],
        groups: this.groupOptions.map((group) => group.key),
      };
    },

    errorMessage(error) {
      const result = error && error.response && error.response.data ? error.response.data.result : null;

      return result && result.message ? result.message : String(error);
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.clearData();
      this.getBranches();
    },
  },
};
</script>
<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.source-pill {
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 600;
  background-color: #f0f2f5;
  border-radius: 8px;
}

.select-all-link {
  color: #133067;
  font-weight: 600;
  text-decoration: none;
}

.select-all-link:hover {
  text-decoration: underline;
}
</style>
